import apiClient from './axios';

const analyticsApi = {
  // Отримати повну статистику dashboard
  getDashboard: (startDate, endDate) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return apiClient.get('/stats/dashboard', { params });
  },

  // Статистика трафіку
  getTrafficStats: (startDate, endDate) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return apiClient.get('/stats/traffic', { params });
  },

  // Аналітика користувачів
  getUsersAnalytics: (startDate, endDate) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return apiClient.get('/stats/users-analytics', { params });
  },

  // Статистика поведінки користувачів
  getBehaviorStats: (startDate, endDate) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return apiClient.get('/stats/behavior', { params });
  },

  // Engagement статистика
  getEngagementStats: (startDate, endDate) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return apiClient.get('/stats/engagement', { params });
  },

  // Аналітика знижок
  getDiscountsAnalytics: (startDate, endDate) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return apiClient.get('/stats/discounts-analytics', { params });
  },

  // Tracking методи (без автентифікації)
  trackPageVisit: (visitData) => {
    return apiClient.post('/stats/track/visit', visitData);
  },

  trackSession: (sessionData) => {
    return apiClient.post('/stats/track/session', sessionData);
  },

  endSession: (sessionId) => {
    return apiClient.post('/stats/track/session/end', { sessionId });
  },

  // Прив'язка сесії до користувача після авторизації
  linkSessionToUser: (sessionId, userId) => {
    return apiClient.post('/stats/track/session/link-user', { sessionId, userId });
  },

  // Старі endpoints для сумісності
  getStats: () => {
    return apiClient.get('/stats');
  },

  getUsersStats: () => {
    return apiClient.get('/stats/users');
  },

  getDepartmentsStats: () => {
    return apiClient.get('/stats/departments');
  },

  getUsageStats: () => {
    return apiClient.get('/stats/usage');
  }
};

export default analyticsApi;
